import React from 'react'
import { Stack, type StackProps } from '@mantine/core'

export type AppStackProps = StackProps

/** Standard vertical layout stack with consistent spacing. */
export default function AppStack ({ spacing = 'sm', ...props }: AppStackProps) {
  return <Stack spacing={spacing} {...props} />
}
